import { ErrorNotification } from "@components/ErrorNotification"
import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import { Field, Form, Formik } from "formik"
import Link from "next/link"
import React, { FC } from "react"
import { SignupFormFields } from "./Fields"
import { useSignupForm } from "./hooks/use-signup-form"

export const SignupForm: FC = () => {
  const { submit, error, status } = useSignupForm()

  return (
    <div className="block h-full w-full max-w-[384px] pt-6">
      <Heading variant="h2" className="mb-8 text-center md:text-left">
        New to Viesus
      </Heading>
      <div className="mb-8 w-full">
        {error && <ErrorNotification message={error} />}
        <Formik
          initialValues={{
            firstNameHjJKLS: "",
            lastNameHjJKLS: "",
            emailHjJKLS: "",
            password: "",
            repeatPassword: "",
            foundViesusThrough: "",
            firstname: "",
            lastname: "",
            email: "",
            passedCaptcha: false,
            newsPreference: {
              "viesus-cloud-product-updates": true,
              "viesus-news": false,
              "viesus-product-updates": false,
            },
          }}
          onSubmit={submit}
          validateOnChange={false}
        >
          <Form className="w-full">
            <SignupFormFields status={status} />
            {/* Honeypot fields to prevent bots from submitting the form */}
            <Field
              type="text"
              name="firstname"
              className="absolute left-0 top-0 z-[-1] h-0 w-0 opacity-0"
              autoComplete="off"
              tabIndex={-1}
            />
            <Field
              type="text"
              name="lastname"
              className="absolute left-0 top-0 z-[-1] h-0 w-0 opacity-0"
              autoComplete="off"
              tabIndex={-1}
            />
            <Field
              type="text"
              name="email"
              className="absolute left-0 top-0 z-[-1] h-0 w-0 opacity-0"
              autoComplete="off"
              tabIndex={-1}
            />
          </Form>
        </Formik>
      </div>
      <Text
        variant="small"
        className="bg-default bg-clip-text text-transparent"
      >
        {"Already have an account? "}
        {
          <Link
            href="/login"
            passHref
            className="bg-hover bg-size-[0%_1px] bg-bottom-left bg-no-repeat no-underline transition-[background-size] duration-150 ease-in-out hover:bg-size-[100%_1px]"
          >
            Log in
          </Link>
        }
        !
      </Text>
      <Text
        variant="micro"
        className="max-w-[364px] text-center text-shade-500 md:text-left"
      >
        By signing up you agree to our{" "}
        <Link
          href="/terms-of-service"
          target="_blank"
          style={{ textDecoration: "underline" }}
        >
          Terms & Services
        </Link>{" "}
        and{" "}
        <Link
          href="/privacy-policy"
          target="_blank"
          style={{ textDecoration: "underline" }}
        >
          Privacy Statement
        </Link>
        .
      </Text>
    </div>
  )
}
